import React from "react";
import styles from "./BetTableTeenMuf.module.css";

const BetTableTeenMuf = ({ playerAScore, playerBScore, onBetClick, exposures = {}, min = "100.0", max = "200K" }) => {
  // Get exposure value - try different key formats
  const getExposure = (selection, playerName) => {
    const playerLetter = playerName?.slice(-1); // "A" or "B"
    const exposureKeys = [
      selection,
      `${selection} ${playerName}`,
      `Player ${playerLetter} ${selection}`,
      `${playerName} ${selection}`,
      selection?.toLowerCase(),
      `${selection} ${playerName}`.toLowerCase(),
      `Player ${playerLetter} ${selection}`.toLowerCase(),
      `${playerName} ${selection}`.toLowerCase(),
    ];

    let exposure = 0;
    for (const key of exposureKeys) {
      if (exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue)) {
          exposure = expValue;
          break;
        }
      }
    }

    return exposure;
  };

  // Check if row should be suspended (if any cell in the row is suspended)
  const isRowSuspended = (score) => {
    const items = [score.a, score.b, score.c];
    return items.some(item => {
      const value = item?.b ?? 0;
      const gstatus = item?.gstatus?.toUpperCase();
      return value === 0 || value === "0" || value === undefined || value === null || gstatus === "SUSPENDED";
    });
  };

  // Render bet cell
  const renderBetCell = (item, selection, playerName, isRowSuspended) => {
    // Check if suspended: value is 0/null OR gstatus is SUSPENDED
    const value = item?.b ?? 0;
    const gstatus = item?.gstatus?.toUpperCase();
    const isSuspended = value === 0 || value === "0" || value === undefined || value === null || gstatus === "SUSPENDED";
    const exposure = getExposure(selection, playerName);

    // For "Top 9" column, show player letter (A or B) instead of odds value
    let displayValue;
    if (selection === "Top 9") {
      displayValue = isSuspended ? 0 : (playerName?.slice(-1) || value || 0);
    } else {
      displayValue = isSuspended ? 0 : (value || 0);
    }

    // If row is suspended, don't apply cell-level suspension class to avoid conflicts
    const cellSuspendedClass = (!isRowSuspended && isSuspended) ? styles.suspended : "";

    return (
      <td
        className={`text-center ${styles.boxW2} ${styles.back} ${cellSuspendedClass}`}
        onClick={() => !isRowSuspended && !isSuspended && onBetClick && onBetClick(displayValue, selection, { b: displayValue }, playerName?.slice(-1))}
        style={{ cursor: (isRowSuspended || isSuspended) ? 'not-allowed' : 'pointer', position: 'relative' }}
      >
        <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '46px' }}>
          <div className="d-block text-bold odds" style={{ fontSize: '12px', fontWeight: 'bold', color: 'black' }}>
            {!isSuspended && displayValue}
          </div>
          <div className="d-block" style={{ color: "black", fontSize: "12px", marginTop: '-12px' }}>
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: 'black' }}>{exposure !== 0 ? (exposure < 0 ? exposure.toFixed(2) : `+${exposure.toFixed(2)}`) : "0"}</div>
          </div>
        </div>
      </td>
    );
  };

  // Render player row
  const renderPlayerRow = (playerName, score) => {
    const rowSuspended = isRowSuspended(score);
    
    return (
      <tr className={rowSuspended ? styles.suspendedRow : ""}>
        <td className={styles.box4} style={{ backgroundColor: '#333d79ff', color: 'white' }}>
          <div style={{ fontSize: '12px', fontWeight: 'bold', color: 'white' }}>{playerName}</div>
        </td>
        {renderBetCell(score.a, "Winner", playerName, rowSuspended)}
        {renderBetCell(score.b, "Top 9", playerName, rowSuspended)}
        {renderBetCell(score.c, `M Baccarat ${playerName?.slice(-1)}`, playerName, rowSuspended)}
      </tr>
    );
  };

  return (
    <div className={styles.teenmuf}>
      <div className={styles.tableResponsive}>
        <table className={`table ${styles.tableBordered}`}>
          <thead>
            <tr>
              <th className={`${styles.box4} ${styles.minMax}`} style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', fontWeight: 'normal' }} className="">
                  {/* <div style={{ fontSize: '10px', color: 'white' }}>Min: </div><div style={{ fontSize: '10px', fontWeight: 'normal', color: 'white' }}>{min}</div> */}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', fontWeight: 'normal' }} className="">
                  {/* <div style={{ fontSize: '10px', color: 'white' }}>Max: </div><div style={{ fontSize: '10px', fontWeight: 'normal', color: 'white' }}>{max}</div> */}
                </div>
              </th>
              <th className={`${styles.boxW2} ${styles.back} text-center`} style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}>Winner</th>
              <th className={`${styles.boxW2} ${styles.back} text-center`} style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}>Top 9</th>
              <th className={`${styles.boxW2} ${styles.back} text-center`} style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}>M Baccarat</th>
            </tr>
          </thead>
          <tbody>
            {renderPlayerRow("Player A", playerAScore)}
            {renderPlayerRow("Player B", playerBScore)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BetTableTeenMuf;

